import config from '@/config';
import axios from 'axios';
import qs from 'qs';
import { userService } from '@/services/user-service';

axios.defaults.headers['Content-Type'] = 'application/x-www-form-urlencoded';
axios.defaults.transformRequest = data => qs.stringify(data);

const ajax = axios.create({
  baseURL: config.apiUrl,
  timeout: 10000,
});

ajax.interceptors.request.use((ajaxConfig) => {
  const user = userService.retrieve();
  const token = user !== null ? user.access_token : null;
  if (token !== null) {
    ajaxConfig.headers.Authorization = `Bearer ${token}`;
  }

  return ajaxConfig;
}, error => Promise.reject(error));

export default ajax;
